/**
 * Favotrip Exclusive op favotrip.de: de aan/uit-regel van de publieke Duitse
 * hub (`/exclusive`) en hotelteaser (`/exclusive/<naam>`) (brief A1, Dennis
 * 04-11-2026: Google Ads in Duitsland en Oostenrijk vanaf 10-11).
 *
 * UIT (standaard): favotrip.de gedraagt zich precies als op main. Elk
 * Exclusive-adres op .de krijgt de 308 naar https://www.favotrip.nl/exclusive
 * (of, met ING_DE_LIVE aan, naar /ing), de aanmeldroute op .de geeft 404 en
 * de Duitse pagina's zijn onbereikbaar (hun interne pad is een 404).
 *
 * AAN: op favotrip.de geven `/exclusive` en `/exclusive/<naam>` de Duitse,
 * prijsvrije pagina's uit `GET /luxe-public-de/deals[/<naam>]`, binnen .de,
 * met het Duitse aanmeldblok (POST /exclusive-toegang/aanmelden via de
 * .de-klantproxy, sessie host-only op .de).
 *
 * Eén constante, zonder imports, zodat de middleware, de browser en de routes
 * onder /api precies dezelfde regel lezen (patroon: luxe-public-flags.js en
 * ing-de-flags.js). Aanzetten is een aparte PR van één regel plus test; een
 * staging-build mag hem aan hebben. Staat de backenddeur (`LUXE_DE_PUBLIEK`)
 * dicht, dan tonen de pagina's een Duitse "niet beschikbaar"-staat; gaat de
 * deur blijvend dicht, dan gaat deze schakelaar in dezelfde ronde weer uit
 * (CLAUDE.md, "Luxe-oppervlakken", punt 4).
 */
export const LUXE_DE_PUBLIEK_LIVE = false;

/** true als de publieke Duitse Exclusive-pagina's op favotrip.de aan staan. */
export function luxeDePubliekLive() {
  return LUXE_DE_PUBLIEK_LIVE === true;
}
